// extracted by mini-css-extract-plugin
export default {"button":"MenuButton_button__8RTF9","active":"MenuButton_active__-NPGB"};